import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { Provider } from "@redotech/redo-model/order";
import { createContext, memo, ReactNode } from "react";

export const EnabledProvidersContext = createContext<
  readonly Provider[] | undefined
>(undefined);

export const EnabledProvidersProvider = memo(function EnabledProvidersProvider({
  children,
}: {
  children: ReactNode;
}) {
  const client = useRequiredContext(RedoMerchantRpcClientContext);

  const enabledProvidersLoad = useLoad(
    (signal) => client.getEnabledProviders({}, { signal }),
    [client],
  );

  // Don't render children until providers are loaded
  if (!enabledProvidersLoad.value) {
    return null;
  }

  return (
    <EnabledProvidersContext.Provider value={enabledProvidersLoad.value ?? []}>
      {children}
    </EnabledProvidersContext.Provider>
  );
});
